import styled from '@emotion/styled';
import { FC, ReactNode } from 'react';

import { Separator, theme, Typography } from '@/shared/design-system';

export const ActionModalBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: ' 0px 16px 16px',
});

export const ActionModalActions = styled('div')({
  display: 'grid',
  gap: '8px',
  gridTemplateColumns: '1fr 1fr',
});

export const ActionModalActionsSingle = styled('div')({
  display: 'flex',
  gap: '8px',
});

const InfoCardRoot = styled('div')(({ theme: t }) => ({
  border: `1px solid ${t.colors.border.subtle}`,
  background: t.colors.background.canvas,
  borderRadius: '12px',
  padding: '16px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

const InfoCardIconRow = styled('div')({
  display: 'flex',
});

const InfoCardBulletList = styled('ul')(({ theme: t }) => ({
  margin: 0,
  paddingLeft: '18px',
  listStyleType: 'none',
  color: t.colors.white[60],
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));

interface ActionInfoCardProps {
  icon: ReactNode;
  title: string;
  description?: string;
  bullets?: string[];
  note?: string;
}

export const ActionInfoCard: FC<ActionInfoCardProps> = ({
  icon,
  title,
  description,
  bullets,
  note,
}) => (
  <InfoCardRoot>
    <InfoCardIconRow>{icon}</InfoCardIconRow>
    <Typography variant="body1" fontWeight={600}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body3" color={theme.colors.white[60]}>
        {description}
      </Typography>
    )}
    {bullets && bullets.length > 0 && (
      <InfoCardBulletList>
        {bullets.map((b) => (
          <Typography key={b} as="li" variant="body3" color={theme.colors.white[60]}>
            {b}
          </Typography>
        ))}
      </InfoCardBulletList>
    )}
    {note && (
      <Typography variant="body3" color={theme.colors.white[60]}>
        {note}
      </Typography>
    )}
  </InfoCardRoot>
);

export const ActionModalSeparator: FC = () => <Separator />;
